import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import FlightDetailPage from "./FlightDetailPage";

// Apply dark mode globally — app is dark-only
document.documentElement.classList.add("dark");

const flightMatch = window.location.pathname.match(/^\/flight\/([^/]+)\/(\d+)\/(\d+)$/);
const root = createRoot(document.getElementById("root")!);

if (flightMatch) {
  root.render(
    <FlightDetailPage
      hex={flightMatch[1]}
      start={Number(flightMatch[2])}
      end={Number(flightMatch[3])}
    />,
  );
} else {
  root.render(<App />);
}
